<template lang="pug">
  v-row 
      v-col(cols="12")
        v-card.rounded-lg.pa-4(flat)

          v-card-title {{$t("settings.categories")}}

          v-list(subheader='' two-line='')
              template(v-for='(category, index) in categories')
                v-list-item( :key='category.id')
                  v-list-item-content
                    v-list-item-title(v-text='category.title')
                    v-list-item-subtitle {{category.videoAssets.items ? category.videoAssets.items.filter(i => !!i).length : 0}} Videos
                  v-list-item-action
                    v-btn(icon color="grey" @click="deleteMe(category.id)")
                      v-icon mdi-delete
                v-divider( v-if="index < categories.length - 1")
              v-list-item
                v-list-item-content
                  v-text-field.mt-3.rounded-lg(:placeholder="$t('config.newCategory')"  filled rounded hide-details dense v-model="newCategory")
                    template(v-slot:append)
                       v-btn.mb-2(@click="addCategory" text color="primary") 
                        | {{$t("general.add")}}
                        v-icon(right) mdi-chevron-right

                //-v-list-item-action.mt-0
                  v-btn.mt-0(@click="addCategory" depressed color="primary") 
                    | {{$t("general.add")}}
                    v-icon(right) mdi-chevron-right
            
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "categories-settings",

  data() {
    return {
      newCategory: "",
    };
  },
  computed: {
    ...mapState({
      categories: (state) => state.settings.categories,
    }),
  },
  methods: {
    addCategory() {
      this.$store.dispatch("settings/ADD_CATEGORY", {
        name: this.newCategory,
      });
      this.newCategory = "";
    },
    deleteMe(id) {
      this.$store.dispatch("settings/DELETE_CATEGORY", id);
    },
  },
  async mounted() {
    this.$store.dispatch("settings/FETCH_CATEGORIES");
  },
};
</script>

<style lang="sass" scoped>
.videoPlayer
  width: 100% !important
  margin-bottom: -5px
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--single-line
    margin-top: 0 !important
</style>
